import Vue from 'vue';
import App from './App.vue';
import CludoVue from '@universityofbristol/cludo-vue';
import store from './store';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: window.location.pathname,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

Vue.config.productionTip = false;
const mountEl = document.getElementById('news-search');
const isGlobal = mountEl.dataset.isGlobal == 'true';
const showThumbnail = mountEl.dataset.showThumbnail == 'true';
const showCategoryFilters = mountEl.dataset.showCategoryFilters == 'true';
const showDateFilters = mountEl.dataset.showDateFilters == 'true';
const RHColumn = mountEl.dataset.rhColumn || '';
const topStoryId = mountEl.dataset.topStory || '';

Vue.use(CludoVue, {
  store: store,
  router: router,
  options: {
    useQuery: true,
    cludoCustomerId: 2541,
    cludoEngineId: 11415,
    // cludoEngineId: 11278, // Course/Programme Engine ID
    queryStatsEnabled: true,
    clickStatsEnabled: true,
    perPage: 10,
    paginationRange: 7,
    sortOnLoad: { Date_date: 'desc' },
    payload: {
      filters: {
        Category: ['News'],
        IsGlobalNews: [isGlobal]
      },
      sort: { Date_date: 'desc' },
      // postFiltersOperator: 'or',
    },
  },
});

console.log('Vue.prototype.$cludo:', Vue.prototype.$cludo);

new Vue({
  render: (h) => h(App, {
    props: {
      showThumbnail: showThumbnail,
      showCategoryFilters: showCategoryFilters,
      showDateFilters: showDateFilters,
      RHColumn: RHColumn,
      topStoryId: topStoryId,
    }
  }),
  store: store,
  router: router,
}).$mount('#news-search');
